import '../../style/login/style-app-login.scss'
import CtaButton from '../../components/ctaButton/CtaButton'
import { useEffect, useState } from 'react'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { loginConnector } from '../../server/connector/loginConnector'
import { useCookies } from 'react-cookie'
import { userStateData } from '../../data/userStateData'

function AppLogIn() {
	const [loggingIn, setLoggingIn] = useState<boolean>(false)
	const [email, setEmail] = useState<string>('')
	const [password, setPassword] = useState<string>('')

	const [loginFailed, setLoginFailed] = useState<boolean>(false)

	const [cookies, setCookie] = useCookies(['userData'])

	useEffect(() => {
		// addLogInButtons()
	}, [])

	const addLogInButtons = () => {
		const googleScript = document.createElement('script')
		const facebookScript = document.createElement('script')

		// Google script was failing to show when loaded from google so created local copy for testing
		// googleScript.src = "https://accounts.google.com/gsi/client"
		googleScript.src = "/scripts/googleClient.js"
		googleScript.async = true
		googleScript.defer = true

		facebookScript.src = 'https://connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v24.0&appId=APP_ID'
		facebookScript.async = true
		facebookScript.defer = true
		facebookScript.crossOrigin = 'anonymous'

		document.body.appendChild(googleScript)
		document.body.appendChild(facebookScript)

		return () => {
			document.body.removeChild(googleScript)
			document.body.removeChild(facebookScript)
		}
	}

	const loginClicked = () => {
		setLoggingIn(true)
		loginConnector.performAppLoginRequest(email, password).then((successRequest) => {
			if (!successRequest) {
				setLoginFailed(true)
				setLoggingIn(false)
			} else {
				// make sure cookies exist check to avoid unassigned value warning
				if (cookies) {
					setCookie("userData", userStateData.getUserData(), {
						path: "/"
					})
					window.location.replace(PAGE_URLS.APP_EXPLORE)
				} else {
					console.log("[AppLogin] - loginClicked() cookies doesn't exist")
				}
			}
		})
	}
	
	return (
		<>
			<div className='section-wrap'>
				<div className='section-content'>
					<div className='log-in-content'>
						<div className='log-in-content-section'>
							<div className='log-in-form'>
								<div className='log-in-form-title'>Sign in to Peyto</div>
								<input 
									className='log-in-form-input' 
									type={'email'} 
									placeholder={'Email'} 
									value={email}
									onChange={(event) => {
										setEmail(event.target.value)
									}}
									disabled={loggingIn}
								/>
								<input 
									className='log-in-form-input' 
									type='password'
									placeholder={'Password'} 
									value={password}
									onChange={(event) => {
										setPassword(event.target.value)
									}}
									disabled={loggingIn}
								/>
								{loginFailed && <div className='log-in-form-login-failed'>
									Log in Failed, please check details and try again
								</div>}
								<CtaButton
									label={loggingIn ? 'Logging In...' : 'Log In'}
									size='medium'
									onClick={() => loginClicked()}
									fullWidth={true}
									disabled={
										email === '' ||
										password === '' ||
										loggingIn
									}
								/>
								<div className='log-in-already-have-account log-in-reset-password'><a href={PAGE_URLS.APP_RESET_PASSWORD}>Forgot password?</a></div>
								<div className='log-in-line-text-span-wrap'>
									<div className='log-in-line-text-span-wrap-span'>or</div>
								</div>
								<div className='log-in-already-have-account'>Don't have an account? <a href={PAGE_URLS.APP_SIGN_UP}>Sign Up</a></div>
								<div className='log-in-form-login-with-wrap'>
									<div id="g_id_onload"
										data-client_id=""
										data-login_uri=""
										data-auto_prompt="false">
									</div>
									<div className="g_id_signin"
										data-type="standard"
										data-size="large"
										data-theme="outline"
										data-text="sign_in_with"
										data-shape="rectangular"
										data-logo_alignment="left">
									</div>
								</div>
								<div 
									className="fb-login-button"
									data-width="500"
									data-size="large"
									data-button-type=""
									data-layout=""
									data-auto-logout-link="false"
									data-use-continue-as="false"
								></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default AppLogIn
